import { render, staticRenderFns } from "./transferRecord.vue?vue&type=template&id=571f7d44&scoped=true"
import script from "./transferRecord.vue?vue&type=script&lang=js"
export * from "./transferRecord.vue?vue&type=script&lang=js"
import style0 from "./transferRecord.vue?vue&type=style&index=0&id=571f7d44&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571f7d44",
  null
  
)

export default component.exports